/** Shared MUI sx used across Tenant Management tabs (matches Offwing Reasons). */

export const tenantManagementPaperSx = {
  bgcolor: "#111",
  color: "#fff",
  border: "1px solid #333",
  p: 2,
} as const;

export const tenantManagementTabsSx = {
  mb: 2,
  "& .MuiTab-root": { color: "#ccc" },
  "& .Mui-selected": { color: "hsl(19 101% 51% / 1) !important" },
  "& .MuiTabs-indicator": { backgroundColor: "hsl(19 101% 51% / 1)" },
} as const;

export const tenantManagementPrimaryButtonSx = {
  bgcolor: "hsl(19 101% 51% / 1)",
  "&:hover": { bgcolor: "hsl(19 101% 41% / 1)" },
} as const;

export const tenantManagementAccordionSx = {
  bgcolor: "#111",
  color: "#fff",
  border: "1px solid #333",
  mb: 0.5,
  "&:before": { display: "none" },
  "&.Mui-expanded": { m: 0, mb: 0.5 },
} as const;

export const tenantManagementAccordionSummarySx = {
  bgcolor: "#1a1a1a",
  borderBottom: "1px solid #333",
  "&:hover": { bgcolor: "#222" },
} as const;

export const tenantManagementTableHeadCellSx = {
  color: "#fff",
  borderColor: "#333",
  background: "#0a0a0a",
} as const;

export const tenantManagementTableBodyCellSx = {
  color: "#fff",
  borderColor: "#333",
} as const;

export const tenantManagementDialogPaperSx = {
  backgroundColor: "#111",
  color: "#fff",
  border: "1px solid #333",
} as const;

export const tenantManagementTextFieldSx = {
  "& .MuiInputLabel-root": { color: "#fff" },
  "& .MuiInputBase-input": { color: "#fff" },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#555" },
} as const;
